import { StagesService } from 'api-clients/monolith';
import { useApiService } from 'hooks';
import React from 'react';

export function useUnscopedStages({
  workflowId,
  perPage = 300,
  query,
}: {
  workflowId?: string;
  perPage?: number;
  query?: string;
}) {
  const fetchStages = React.useCallback(
    () => StagesService.getInternalApiStages(workflowId, perPage, true, query),
    [query, workflowId, perPage],
  );

  return useApiService(fetchStages);
}
